(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topeak-contact-faq"] && !Shopify.designMode) return;
  try {
    
  const contactFaqAnchor = 'topeak-contact-faq';

  const scrollToContactFaq = (section) => {
    if (window.location.hash !== `#${contactFaqAnchor}`) {
      return;
    }

    requestAnimationFrame(() => {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  document.querySelectorAll(`#${contactFaqAnchor}`).forEach((section) => {
    scrollToContactFaq(section);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot = event.target?.querySelector?.(`#${contactFaqAnchor}`);

    if (sectionRoot) {
      scrollToContactFaq(sectionRoot);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topeak-product-hero"] && !Shopify.designMode) return;
  try {
    
  const formatProductHeroMoney = (cents, format) => {
    const safeCents = Math.max(0, Number(cents) || 0);
    const amount = (safeCents / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(safeCents / 100));
    const amountParts = amount.split('.');
    amountParts[0] = amountParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amountWithComma = amountParts.join('.');

    if (!format) {
      return (safeCents / 100).toFixed(2);
    }

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  const calculateProductHeroTotalCents = (quantity, unitPriceCents, quantityPriceBreaks) => {
    const normalizedQuantity = Math.max(0, Number(quantity) || 0);
    let unitCents = Math.max(0, Number(unitPriceCents) || 0);
    const breaks = (quantityPriceBreaks || [])
      .slice()
      .sort((a, b) => Number(a.quantity) - Number(b.quantity));

    for (const priceBreak of breaks) {
      if (normalizedQuantity >= Number(priceBreak.quantity)) {
        const breakUnit = Math.max(0, Number(priceBreak.priceCents) || 0);
        if (breakUnit > 0) {
          unitCents = breakUnit;
        }
      }
    }

    return unitCents * normalizedQuantity;
  };

  const getProductHeroPricingContext = (section) => {
    if (!section) return null;

    const formComponent = section.querySelector('product-form-component[data-add-label]');
    const quantitySelector = section.querySelector('quantity-selector-component');
    const quantityInput = section.querySelector('.topeak-product-hero__quantity [ref="quantityInput"], .topeak-product-hero__quantity input[name="quantity"]');

    if (!formComponent) return null;

    let quantityPriceBreaks = [];
    try {
      quantityPriceBreaks = JSON.parse(formComponent.dataset.quantityPriceBreaks || '[]');
    } catch (error) {
      quantityPriceBreaks = [];
    }

    const quantity = Number(
      quantitySelector?.getValue?.() || quantityInput?.value || formComponent.dataset.quantityDefault || 1
    );

    return {
      formComponent,
      addText: section.querySelector('.topeak-product-hero__add-text'),
      addButton: section.querySelector('.topeak-btn--product-hero-add'),
      checkedPack: section.querySelector('.topeak-product-hero__pack-input:checked'),
      baseLabel: formComponent.dataset.addLabel || 'Add to cart',
      unitPriceCents: Number(formComponent.dataset.unitPriceCents) || 0,
      moneyFormat: formComponent.dataset.moneyFormat,
      quantityPriceBreaks,
      quantity,
    };
  };

  const updateProductHeroAddText = (section) => {
    const context = getProductHeroPricingContext(section);
    if (!context?.addText) return;

    const { addText, addButton, checkedPack, baseLabel, unitPriceCents, moneyFormat, quantityPriceBreaks, quantity } = context;

    if (addButton instanceof HTMLButtonElement && addButton.getAttribute('aria-busy') === 'true') {
      return;
    }

    const totalCents = calculateProductHeroTotalCents(quantity, unitPriceCents, quantityPriceBreaks);
    const formattedPrice = formatProductHeroMoney(totalCents, moneyFormat);

    addText.textContent = `${baseLabel.toUpperCase()} - ${formattedPrice}`;

    if (addButton instanceof HTMLButtonElement && checkedPack instanceof HTMLInputElement) {
      addButton.disabled = checkedPack.dataset.available === 'false';
    }
  };

  const setProductHeroAddLoading = (section, isLoading) => {
    if (!section) return;

    const addButton = section.querySelector('.topeak-btn--product-hero-add');
    const addText = section.querySelector('.topeak-product-hero__add-text');
    if (!(addButton instanceof HTMLButtonElement) || !addText) return;

    if (isLoading) {
      if (!addButton.dataset.idleLabel) {
        addButton.dataset.idleLabel = addText.textContent || '';
      }
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      addButton.classList.add('topeak-btn--loading');
      addText.textContent = (addButton.dataset.loadingLabel || 'Adding...').toUpperCase();
      return;
    }

    addButton.classList.remove('topeak-btn--loading');
    addButton.removeAttribute('aria-busy');
    delete addButton.dataset.idleLabel;
    updateProductHeroAddText(section);
  };

  const clearProductHeroAddLoading = () => {
    document.querySelectorAll('.topeak-product-hero[data-product-hero-add-pending="true"]').forEach((section) => {
      const timeoutId = Number(section.dataset.productHeroAddTimeout || 0);
      if (timeoutId) {
        window.clearTimeout(timeoutId);
        delete section.dataset.productHeroAddTimeout;
      }
      section.removeAttribute('data-product-hero-add-pending');
      setProductHeroAddLoading(section, false);
    });
  };

  const updateProductHeroAddLabel = (packInput) => {
    const section = packInput.closest('.topeak-product-hero');
    if (!section) return;

    const packQuantity = packInput.dataset.cartQuantity || packInput.value || '1';
    const quantitySelector = section.querySelector('quantity-selector-component');

    if (quantitySelector?.setValue) {
      quantitySelector.setValue(packQuantity);
    }

    updateProductHeroAddText(section);
  };

  const syncProductHeroDetailsAccordion = (accordion) => {
    if (!(accordion instanceof HTMLDetailsElement)) return;
    if (window.matchMedia('(min-width: 750px)').matches) {
      accordion.open = true;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.type !== 'add-to-cart-form') return;

    const section = form.closest('.topeak-product-hero');
    if (!section) return;

    section.setAttribute('data-product-hero-add-pending', 'true');
    setProductHeroAddLoading(section, true);
    section.dataset.productHeroAddTimeout = String(
      window.setTimeout(clearProductHeroAddLoading, 10000)
    );
  });

  document.addEventListener('cart:update', clearProductHeroAddLoading);
  document.addEventListener('cart:error', clearProductHeroAddLoading);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.classList.contains('topeak-product-hero__pack-input')) return;
    updateProductHeroAddLabel(target);
  });

  document.addEventListener('quantity-selector:update', (event) => {
    const section = event.target?.closest?.('.topeak-product-hero');
    if (!section) return;
    updateProductHeroAddText(section);
  });

  document.addEventListener('input', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.name !== 'quantity') return;
    const section = target.closest('.topeak-product-hero');
    if (!section) return;
    updateProductHeroAddText(section);
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.topeak-product-hero__gallery-thumb[data-gallery-src]');
    if (!(thumb instanceof HTMLButtonElement)) return;

    const gallery = thumb.closest('.topeak-product-hero__gallery');
    if (!gallery) return;

    const mainImage = gallery.querySelector('.topeak-product-hero__gallery-image--main');
    if (!(mainImage instanceof HTMLImageElement)) return;

    const nextSrc = thumb.dataset.gallerySrc;
    if (!nextSrc) return;

    mainImage.src = nextSrc;
    if (thumb.dataset.gallerySrcset) {
      mainImage.srcset = thumb.dataset.gallerySrcset;
    } else {
      mainImage.removeAttribute('srcset');
    }

    gallery.querySelectorAll('.topeak-product-hero__gallery-thumb[data-gallery-src]').forEach((item) => {
      item.classList.remove('topeak-product-hero__gallery-thumb--active');
      item.setAttribute('aria-current', 'false');
    });
    thumb.classList.add('topeak-product-hero__gallery-thumb--active');
    thumb.setAttribute('aria-current', 'true');
  });

  const initProductHeroSections = () => {
    document.querySelectorAll('.topeak-product-hero').forEach((section) => {
      updateProductHeroAddText(section);

      section.querySelectorAll('.topeak-product-hero__accordion--details').forEach((accordion) => {
        syncProductHeroDetailsAccordion(accordion);
      });
    });
  };

  initProductHeroSections();
  window.addEventListener('resize', initProductHeroSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topeak-shop-all-product-grid"] && !Shopify.designMode) return;
  try {
    

  const initShopAllProductGridTabs = (section) => {
    const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
    const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

    if (!tabs.length || !panels.length) {
      return;
    }

    const activateTab = (nextTab) => {
      if (!nextTab) {
        return;
      }

      const panelId = nextTab.getAttribute('aria-controls');

      for (const tab of tabs) {
        const isSelected = tab === nextTab;

        tab.classList.toggle(
          'topeak-shop-all-product-grid__tab--active',
          isSelected
        );

        tab.setAttribute(
          'aria-selected',
          isSelected ? 'true' : 'false'
        );

        tab.tabIndex = isSelected ? 0 : -1;
      }

      for (const panel of panels) {
        const isActive = panel.id === panelId;

        panel.hidden = !isActive;

        panel.classList.toggle(
          'topeak-shop-all-product-grid__panel--active',
          isActive
        );

        if (isActive) {
          panel.dispatchEvent(
            new CustomEvent(
              'topeak:reveal-product-cards',
              { bubbles: true }
            )
          );
        }
      }
    };

    const getInitialTabFromUrl = () => {
      const tabParam = new URLSearchParams(window.location.search).get('tab');

      if (tabParam === 'bundles' || tabParam === 'bundle') {
        return 'bundles';
      }

      if (tabParam === 'focus_picks' || tabParam === 'focus-picks') {
        return 'focus_picks';
      }

      return null;
    };

    const productsListAnchor = 'topeak-shop-all-products';

    const shouldScrollToProducts = () => {
      if (window.location.hash === `#${productsListAnchor}`) {
        return true;
      }

      return getInitialTabFromUrl() !== null;
    };

    const scrollToProductsList = () => {
      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    };

    const initialTab = getInitialTabFromUrl();

    if (initialTab) {
      const targetTab = tabs.find(
        (tab) => tab.dataset.tab === initialTab
      );

      if (targetTab) {
        activateTab(targetTab);
      }
    }

    if (shouldScrollToProducts()) {
      requestAnimationFrame(() => {
        scrollToProductsList();
      });
    }

    for (const tab of tabs) {

      tab.addEventListener('click', () => {
        activateTab(tab);
      });

      tab.addEventListener('keydown', (event) => {

        const currentIndex = tabs.indexOf(tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();

        activateTab(tabs[nextIndex]);
        tabs[nextIndex].focus();
      });
    }
  };

  document
    .querySelectorAll('.topeak-shop-all-product-grid')
    .forEach((section) => {
      initShopAllProductGridTabs(section);
    });

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      const sectionRoot =
        event.target?.querySelector?.(
          '.topeak-shop-all-product-grid'
        );

      if (sectionRoot) {
        initShopAllProductGridTabs(sectionRoot);
      }

    }
  );


  } catch(e) { console.error(e); }
})();
})();
